export enum TipoHuesped {
    titular = "Titular",
    adicional = "Adicional",
    extra = "Extra",
}

export enum GeneroHuesped {
    masculino = "Masculino",
    femenino = "Femenino",
    no_binario = "No binario",
}

export enum TipoDocumentoHuesped {
    ine = "INE",
    pasaporte = "Pasaporte",
    licencia = "Licencia de conducir",
    otro = "Otro",
}

export interface RegistroHuespedes {
    dashboard: Dashboard
    respuesta: Respuesta
}

export interface ConteoPorValor {
    label: string
    total: number
}

export interface Dashboard {
    total_registros: number
    total_titulares: number
    total_acompanantes: number
    por_genero: ConteoPorValor[]
    por_nacionalidad: ConteoPorValor[]
    por_tipo_documento: ConteoPorValor[]
}

export interface Respuesta {
    pagina_actual: number
    registros_por_pagina: number
    tabla_registro_huespedes: TablaRegistroHuesped[]
    total_paginas: number
    total_registros: number
}

export interface TablaRegistroHuesped {
    registro_id: string
    folio_ticket: string
    tipo_huesped: TipoHuesped
    genero: GeneroHuesped | null
    nombre: string
    // Formato dd/MM/yyyy
    fecha_nacimiento: string | null
    nacionalidad: string | null
    tipo_documento: TipoDocumentoHuesped
    numero_documento: string | null
    curp: string | null
    direccion: string | null
    // Formato dd/MM/yyyy
    fecha_entrada: string
    // Formato HH:mm
    hora_entrada: string
    // Formato dd/MM/yyyy
    fecha_salida: string
    // Formato HH:mm
    hora_salida: string
    habitacion: string
}
